import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {UpdateInfo} from "@/store/artifact/types";
import ArtifactUtils from "@/utils/artifact-utils";
import Container = Phaser.GameObjects.Container;
import {ArtifactBasePanel} from "@/scenes.ui/artifact-base-panel";
import {SquareButton} from "@/scenes.ui/square-button";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class ArtifactMaxLevelPanel extends ArtifactBasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, ui: UpdateInfo,
                takeOffCallback: () => unknown, slotX: number, slotY: number, container: Container) {
        super(scene, canvas, slotX, slotY, container);
        this.setScale(1 / CU.S, 1 / CU.S);

        const title = TextUtils.addTextByFamily(this.scene, ui.currName.toUpperCase(), 0, -282, '#ffffff', 16,
            'normal', 420, Fonts.ARIAL_MT)
            .setOrigin(0.5, 0.5);

        let levelText = TextUtils.addTextByFamily(scene, String(ui.currentLevel) + Tr('y.uroven').toUpperCase(),
            0, -200, '#ffedc6', 18, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let light = SpriteUtils.addSprite(this.scene, 0, -120, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.8);
        let item = SpriteUtils.addSprite(this.scene, 0, -120, ui.atlasKey, ui.currImageKey);
        let effect = TextUtils.addTextAdvanced(scene, ArtifactUtils.getEffectText(ui.effectType, ui.currLevelValue), 0, -80,
            '#e0e0e0', 15, 'normal', 150, 'center', 2, Fonts.ARIAL_MT);

        let maxLevelLabel = TextUtils.addTextAdvanced(scene, Tr('artefakt.na.maksimalnom.urovne'), 0, 40,
            '#716f6a', 12, 'normal', 250, 'center', 2, Fonts.ARIAL_MT);

        let takeOffButton = new SquareButton(this.scene, -80, 220, 0, Keys.UI_ART_PALE_BUTTON,
            Keys.ATLAS_PROFILE, Keys.UI_ART_TAKE_OFF, Tr('peredat'), true);

        let okButton = new SquareButton(this.scene, 80, 220, 0,
            Keys.UI_ART_BROWN_BUTTON, Keys.ATLAS_PROFILE, Keys.UI_GOLDEN_CHECK, Tr('zakrit'), false);

        this.add(takeOffButton);
        this.add(okButton);

        takeOffButton.setCallback(() => {
            if (this.isOnTop()) {
                takeOffCallback();
            }
        });

        okButton.setCallback(() => {
            if (this.isOnTop()) {
                this.close();
            }
        });

        this.add([title, levelText, light, item, effect, maxLevelLabel,
            takeOffButton, okButton]);
    }
}
